// extracted by css-extract-rspack-plugin
export default {"cls1":"NewsHeader-cls1_Iae","cls2":"NewsHeader-cls2_qDL NewsHeader-cls1_Iae"};